import {useEffect, useState} from 'react';
import {Card, Button, Row, Col, Divider} from 'antd';
import {LightUploadModal} from "./LightUploadModal";
import {getRowMetrics, insertRowMetrics} from "../../api/Api";
import {RowMetricType} from "../../api/Constants";
import * as dayjs from "dayjs";
import {DatePickerWidget} from "../widget/DatePickerWidget";
import {LightChart} from "./LightChart";

export const RoomLightTab = ({rows, onRefresh, onApiFail, plants, props}) => {
    const [modalOpen, setModalOpen] = useState(false);

    const [rowMetrics, setRowMetrics] = useState([]);

    // date pickers
    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const now = dayjs();
    const before = (now.subtract(1, 'day'));
    const [startDate, setStartDate] = useState(before.toString());
    const [endDate, setEndDate] = useState(now.toString());
    const [displayStartDate, setDisplayStartDate] = useState(before.toString());
    const [displayEndDate, setDisplayEndDate] = useState(now.toString());

    useEffect(() => {
        if (rows === undefined) {
            return;
        }

        const rowIds = rows.map(r => {
            return r.id;
        })

        getRowMetrics(rowIds, startDate, endDate).then(r => {
            setRowMetrics(r.map((row, index) => {
                return {
                    ...row,
                    key: index,
                }
            }));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })

    }, [rows, startDate, endDate, onApiFail])

    const onModalOpen = () => {
        setModalOpen(true);
    }

    const onModalOk = (values, rowMap, lightType, isDelete, cb) => {
        const promises = [];

        for (const [rowId, value] of Object.entries(rowMap)) {
            if (value) {
                promises.push(insertRowMetrics(rowId, lightType, values, isDelete))
            }
        }

        Promise.all(promises).then(r => {
            if (onRefresh) onRefresh();
            if (cb) cb();
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
        setModalOpen(false);
    }

    const onModalCancel = () => {
        setModalOpen(false);
    }

    const onStartDateChange = (dateString, dateJs) => {
        // dueDate will be fed to the backend and retained correctly as a local date/time via mysql
        setStartDate(dateString);

        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayStartDate(dateJsString);
    }

    const onEndDateChange = (dateString, dateJs) => {
        // dueDate will be fed to the backend and retained correctly as a local date/time via mysql
        setEndDate(dateString);

        const dateJsString = dateJs.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayEndDate(dateJsString);
    }


    const cardTitle = <b>
        Lighting
    </b>

    const cardStyle = {
        textAlign: 'left',
        marginTop: '5px',
        marginBottom: '5px',
    }

    const dateLabelStyle = {
        marginTop: '5px'
    }

    const upperLights = rowMetrics.filter(light => {
        return light.metric === RowMetricType.UpperLight;
    });

    const lowerLights = rowMetrics.filter(light => {
        return light.metric === RowMetricType.LowerLight;
    })

    return <Card style={cardStyle} title={cardTitle} >
        <LightUploadModal rows={rows} open={modalOpen} onOk={onModalOk} onCancel={onModalCancel} />
        <Button onClick={onModalOpen}>Upload Light CSV</Button>
        <Divider />
        <Row>
            <Col span={2} style={dateLabelStyle}>
                <b>Start Date:</b>
            </Col>
            <Col>
                <DatePickerWidget placeholder={'Start'} onChange={onStartDateChange} date={displayStartDate} />
            </Col>
        </Row>
        <Row>
            <Col span={2} style={dateLabelStyle}>
                <b>End Date:</b>
            </Col>
            <Col>
                <DatePickerWidget placeholder={'End'} onChange={onEndDateChange} date={displayEndDate} />
            </Col>
        </Row>
        <Divider />
        {(upperLights.length > 0) &&
            <LightChart rows={rows} events={upperLights} title={"Upper Lights"}/>
        }
        {(lowerLights.length > 0) &&
            <LightChart rows={rows} events={lowerLights} title={"Lower Lights"}/>
        }
    </Card>
}